import React from 'react';
import { useStyles } from './styles';
import { Card, CardContent, Typography, Slide } from '@mui/material';
import {
  Column,
  FieldTitleDashboard,
  Meta,
  Divider,
} from '../../../../components';

export default function AppHelp({ history }) {
  return null;
}
